import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class SerializeContext {
  constructor() {
    _defineProperty(this, "objectIds", new Set());
  }
  // future: add serialization args, such as whether Date should require special handling

  /** Add to the object ids.   Return true iff it already exists in the set */
  addObjectId(objectId) {
    if (this.objectIds.has(objectId)) {
      return true;
    }
    this.objectIds.add(objectId);
    return false;
  }
}
//# sourceMappingURL=SerializeContext.js.map
